<template>
  <div id="inventory-stock-detail">
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <div class="d-flex mb-1">
              <div class="inventory-stock-header">Total Stock</div>
            </div>
            <div
              class="d-flex flex-wrap justify-content-between"
              :class="
                stockRef ? 'justify-content-between' : 'justify-content-end'
              "
            >
              <div>
                <div v-if="stockRef" class="d-flex align-content-center mb-1">
                  <div class="inventory-label">Reference</div>
                  <b-form-input
                    id="ref-inventory"
                    v-model="stockRef"
                    class="w-100"
                    placeholder="Reference"
                    disabled
                  />
                </div>
              </div>
              <div class="d-flex flex-wrap justify-content-end mb-1">
                <view-data-button
                  @onViewData="confirmViewData"
                  class="mr-4"
                  :isViewed="isVerified"
                />
                <v-select
                  v-model="formStatus.status"
                  class="v-select-filter v-select-filter-status bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
                <div
                  class="
                    search-container
                    mb-1 mb-md-0
                    mr-0
                    ml-0 ml-xl-2 ml-lg-1
                  "
                >
                  <search :on-search-input="onSetValueSearch" />
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="stockTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table normal-height"
              > -->
              <b-table
                :fields="fields"
                :items="stockTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical normal-height"
              >
                <template #cell(redeem_ref)="data">
                  <span class="stock-redeem-ref">{{ data.value || "-" }}</span>
                </template>
                <template #cell(exp_time)="data">
                  <span>{{ data.value || "-" }}</span>
                </template>
                <template #cell(status)="data">
                  <div
                    class="inventory-status-stock"
                    :class="resolveStockStatusClass(data.item.status)"
                  >
                    {{ resolveStockStatusLabel(data.item.status) }}
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import ManageButton from "@/views/components/button/ManageButton.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useInventoryStockDetail from "./hooks/useInventoryStockDetail";
import ViewDataButton from "@/views/components/button/ViewDataButton.vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    ManageButton,
    PaginationWithReorder,
    ViewDataButton,
  },
  setup() {
    const {
      stockRef,
      formStatus,
      statusOption,
      fields,
      loading,
      stockTable,
      resolveStockStatusLabel,
      resolveStockStatusClass,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      confirmViewData,
      isVerified,
    } = useInventoryStockDetail();
    return {
      stockRef,
      formStatus,
      statusOption,
      fields,
      loading,
      stockTable,
      resolveStockStatusLabel,
      resolveStockStatusClass,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      confirmViewData,
      isVerified,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/inventory/history-stock-detail.css";
</style>
